<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default { 
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Статусы',
                        url: `/settings/${this?.$route?.fullPath?.split('/')[2]}/dialogs`
                    },
                    {
                        title: 'Настройки',
                        url: 'dialogs/settings'
                    },
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    }
</script>